<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Video Call</div>
      </base-header>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <base-card>
          <div slot="card-header">
            <v-subheader dark>Recent chat</v-subheader>
            <v-row class="pa-2 mb-2">
              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/1.jpg" alt="John"></v-progress-circular>
              </v-avatar>

              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/2.jpg" alt="John"></v-progress-circular>
              </v-avatar>
              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/3.jpg" alt="John"></v-progress-circular>
              </v-avatar>
              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/4.jpg" alt="John"></v-progress-circular>
              </v-avatar>
              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/5.jpg" alt="John"></v-progress-circular>
              </v-avatar>
              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/6.jpg" alt="John"></v-progress-circular>
              </v-avatar>
              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/7.jpg" alt="John"></v-progress-circular>
              </v-avatar>
              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/8.jpg" alt="John"></v-progress-circular>
              </v-avatar>
              <v-avatar color="indigo" size="100" class="ml-5">
                <v-progress-circular :size="100" indeterminate color="primary"> <img style="width:100px"
                       src="../../assets/images/users/9.jpg" alt="John"></v-progress-circular>
              </v-avatar>
            </v-row>
          </div>
          <div slot="card-body">



          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row>

      <v-col cols="12" md="4" sm="12" v-for="user in users" :key="user.name">
        <v-card class="rounded-lg" height="255">
          <v-img height="255px" :src="require(`../../assets/images/users/${user.img}.jpg`)">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-btn color="white" class="rounded-lg ma-1" icon outlined small>
                <v-icon> mic_off</v-icon>
              </v-btn>
              <v-btn color="white" class="rounded-lg ma-1" icon outlined small>
                <v-icon> videocam_off</v-icon>
              </v-btn>
              <v-toolbar-title class="text-h6 white--text pl-0">

              </v-toolbar-title>

              <v-toolbar-title class="text-h6 white--text pl-0">

              </v-toolbar-title>

              <v-spacer></v-spacer>



            </v-app-bar>

            <v-card-title class="white--text mt-15 ">

              <v-chip class="justify-end mt-15" color="primary" label>
                <v-icon left>
                  mdi-account-circle-outline
                </v-icon>
                {{user.name}}
              </v-chip>

            </v-card-title>
          </v-img>

        </v-card>
      </v-col>





    </v-row>
    <v-row align="center" justify="center">
      <v-col class="text-center" cols="12">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-2 rounded-lg my-2" color="" v-bind="attrs" v-on="on">
              <v-icon dark>
                linked_camera
              </v-icon>
            </v-btn>

          </template>
          <span>Photo</span>
        </v-tooltip>
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-2 rounded-lg my-2" color="" v-bind="attrs" v-on="on">
              <v-icon dark>
                crop_free
              </v-icon>
            </v-btn>

          </template>
          <span>Full</span>
        </v-tooltip>
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-2 rounded-lg my-2" color="" v-bind="attrs" v-on="on">
              <v-icon dark>
                videocam_off
              </v-icon>
            </v-btn>

          </template>
          <span>Video</span>
        </v-tooltip>

        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-2 rounded-lg my-2" color="" v-bind="attrs" v-on="on">
              <v-icon dark>
                mic_off
              </v-icon>
            </v-btn>

          </template>
          <span>Microfone</span>
        </v-tooltip>

      </v-col>
    </v-row>

  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        users: [{
          name: 'Carol',
          img: '1'
        }, {
          name: 'Beatriz',
          img: '2'
        }, {
          name: 'Camila',
          img: '3'
        }, {
          name: 'Carlos',
          img: '4'
        }, {
          name: 'Rubia',
          img: '5'
        }, {
          name: 'Gustavo',
          img: '6'
        }, ],
      }
    },

  }
</script>